import React, { Component, useState } from "react";
import Logo from '../../images/logo.png';
import { useTranslation } from "react-i18next";

export default function Features() {
  const { t, i18n } = useTranslation();
  const [langActive, setLangActive] = useState(localStorage.getItem("selectLang"));

  const changeLanguage = (event, param) => {
    console.log(event);
    console.log(param);
    setLangActive(param);
    localStorage.setItem("selectLang", param);

    const languageValue = param //event.target.value
    i18n.changeLanguage(languageValue);
  }

  return (
    <>
      <div><a href="/" title="Way Almanac Engine​"><img src={Logo} alt="Way Almanac Engine​" className="img-fluid"/></a></div>
      
      <div className="btn-box">
          <button type="button" onClick={event => changeLanguage(event, 'en')}  className={(langActive == 'en') ? 'btn eng-btn active' : 'btn eng-btn'}>English</button>
          <button type="button" onClick={event => changeLanguage(event, 'zh')} className={(langActive != 'en') ? 'btn chi-btn active' : 'btn chi-btn'}>华语</button>
      </div>
    </>
  )
}